import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/main.sass';
import App from './App';
import {MsalProvider} from "@azure/msal-react";
import {PublicClientApplication} from "@azure/msal-browser";
import { msalConfig } from './config/authConfig';

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
      <MsalProvider instance={msalInstance}>
    <App />
      </MsalProvider>
  </React.StrictMode>
);
